
import { defineComponent } from "vue";

import store from "@/store";

const LIGHT_THEME = "light-theme";
const DARK_THEME = "dark-theme";

function browserPreferedTheme() {
  const preferDark = window.matchMedia("(prefers-color-scheme: dark)").matches;

  return preferDark ? DARK_THEME : LIGHT_THEME;
}

export default defineComponent({
  name: "ThemeToggle",
  mounted() {
    const defaultTheme = browserPreferedTheme();
    store.setUserTheme(defaultTheme);
  },
  methods: {
    toggleTheme() {
      const currentValue = store.getUserTheme();
      const newValue = currentValue === LIGHT_THEME ? DARK_THEME : LIGHT_THEME;

      store.setUserTheme(newValue);
    },
  },
});
